"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const carouselImages = [];
export default function Hero() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: carouselRef,
    isVisible: isCarouselVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="192968" id="herosplitwithcta" className="dark relative min-h-[31svh] w-full mr-0 overflow-hidden bg-[#11263C] flex items-start pt-2 pb-20 !border-dotted !border-1 border-[rgb(17,38,60)] lg:py-0">
      {}

      <div className="relative z-10 mx-0 w-full px-0">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0 items-stretch">
          
          {}
          <div className="lg:col-span-7 bg-[#11263C] lg:overflow-hidden">
            <div className="container mx-auto px-6 lg:px-12 h-full flex items-center lg:translate-x-[20%]">
              <div ref={textRef} className="flex flex-col items-start justify-center transition-all duration-1000 ease-out relative z-20 translate-y-0 opacity-100 !w-[330px] -translate-x-[5%] ![padding:40px_10px_40px_0px] lg:translate-x-[15%]">
                <h1 className="font-sans font-bold tracking-tight text-white leading-[1.1] mb-3 ![padding:0px_0px_5px_0px] !text-4xl !w-[380px]">Ekonomisk tydlighet för framåtblickande företag</h1>
                <p className="max-w-2xl leading-relaxed mb-10 font-normal text-base text-white/90 !w-[440px]">Vi säkerställer kontroll över din ekonomi, implementerar rätt system för din verksamhet och erbjuder rådgivning som driver resultat – så att du kan fokusera på det som skapar mest värde.</p>
                <Button asChild size="lg" className="h-16 px-10 text-lg font-medium bg-[#D33F49] text-white hover:bg-[#D33F49]/90 transition-colors shadow-lg shadow-[#D33F49]/10 mb-10">
                  <Link to="#" className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive rounded-md has-[>svg]:px-4 h-16 px-10 text-lg font-medium transition-colors shadow-lg shadow-[#D33F49]/10 mb-10 !text-[hsl(0,0%,100%)] !bg-[hsl(358,59%,51%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-[#D33F49]/90">
                    Kontakta oss
                  </Link>
                </Button>
              </div>
            </div>
          </div>

          {}
          <div ref={carouselRef} style={{
          transform: 'scaleX(1.3)',
          transformOrigin: 'left'
        }} className="w-full min-h-[400px] relative transition-all duration-1000 delay-200 ease-out z-10 bg-[#0B1219] translate-y-0 opacity-100 !m-0 lg:col-span-5 lg:min-h-[600px] lg:[clip-path:polygon(144px_0,200%_0,200%_100%,0_100%)] lg:-translate-x-[30%] after:content-[''] after:absolute after:inset-y-0 after:left-full after:w-screen after:bg-[#0B1219]">
            <div className="absolute inset-0 w-full h-full !bg-[url(https://cuddly-wahoo.10web.cloud/wp-content/uploads/2026/04/post_effektiva-hrstrategier-fr-smfretag-i-sverige.webp)] bg-cover bg-center bg-no-repeat">
              

              {}
              <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-[#0B1219] to-transparent z-10 pointer-events-none" />
              <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#0B1219] to-transparent z-10 pointer-events-none" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}